import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export const DossieLoading: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        flexGrow: 1,
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'radial-gradient(circle at 50% -20%, #ffffff 0%, #f0ebf5 100%)',
        padding: 2
      }}
    >
      <Box
        sx={{
          backgroundColor: '#ffffff',
          borderRadius: '24px',
          boxShadow: '0 24px 48px -12px rgba(114, 57, 137, 0.25), 0 4px 24px rgba(0,0,0,0.04)',
          border: '1px solid rgba(255,255,255,0.8)',
          padding: { xs: 4, md: 6 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 400,
          width: '100%',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '6px',
            backgroundColor: 'primary.main',
          },
        }}
      >
        <style>
          {`
            @keyframes pulseRing {
              0% { transform: scale(0.9); box-shadow: 0 0 0 0 rgba(114, 57, 137, 0.2); }
              70% { transform: scale(1); box-shadow: 0 0 0 25px rgba(114, 57, 137, 0); }
              100% { transform: scale(0.9); box-shadow: 0 0 0 0 rgba(114, 57, 137, 0); }
            }
          `}
        </style>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: '#f8f5fb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 4,
            border: '2px solid rgba(114, 57, 137, 0.1)',
            animation: 'pulseRing 2s infinite cubic-bezier(0.24, 0, 0.38, 1)',
          }}
        >
          <SearchIcon sx={{ fontSize: 36, color: '#723989' }} />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 800, color: '#1e293b', mb: 1.5, letterSpacing: '-0.5px', textAlign: 'center' }}>
          Gerando Dossiê...
        </Typography>
      </Box>
    </Box>
  );
};
